import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { FocusError } from 'focus-formik-error';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import readXlsxFile from 'read-excel-file';
import * as Yup from 'yup';
import { Portals } from '../../../API';
import { updateLoader } from '../../../_redux/LoaderSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import {
  patchApi,
  getApi,
  postApi,
  putApi,
  sessionExpired,
} from '../../../_redux/_apiHelpers/_apihelper';
import GetJobId from '../../../_utilities/GetJobId';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import RightSideBar from '../../../components/Rightsidebar/RightSideBar';
import './Venders.css';

import { GetUserId, GetUserInfo } from '../../../_utilities/getUserInfo';
import { ProfileIcon } from '../../../Icons/profileIcon';
import { DashboardPlusicon } from '../../../Icons/DashboardPlusicon';
const Vendors = ({ vendorId }) => {
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [config, setConfig] = useState(configuration);
  const [filterValue, setFilterValue] = useState('');
  const [isLoadDoc, setIsLoadDoc] = useState(true);
  const [portals, setPortals] = useState('');
  const [isEditVendor, setIsEditVendor] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState('');
  const vendorsForm = JSON.parse(JSON.stringify(iniValues));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialSnackbar = { type: '', message: '' };

  let getJobCode = GetJobId();

  const [getUserId, setGetUserId] = useState(null);

  useEffect(() => {
    async function init() {
      const userIdData = await GetUserId();
      setGetUserId(userIdData);
    }
    init();
  }, []);

  useEffect(() => {
    if (isLoadDoc === true && getUserId !== null) {
      let obj1 = { current: config.currentPage, offset: 1 };
      fetchData(obj1);
      fetchPortalsList(getUserId);
      setIsLoadDoc(false);
    }
  }, [isLoadDoc, getUserId]);

  const fetchData = async (obj) => {
    setVendors([]);
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    try {
      const res = await getApi(
        `/mgmt/customer/vendor/${vendorId}/users?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );

      const jsonData = res.data;
      const myData = jsonData.vendorUsers || jsonData.user;

      if (jsonData.code === 200 && Array.isArray(myData) && myData.length > 0) {
        dispatch(updateLoader(false));

        const updatedConfig = {
          ...config,
          totalRecords: myData[0]?.total_count ?? 0,
          currentPage: obj.current,
        };

        setConfig(updatedConfig);
        setVendors(myData);
      } else {
        dispatch(updateLoader(false));
        // dispatch(
        //   updateSnackbar({
        //     type: 'success',
        //     message: jsonData?.message || 'No data found',
        //   })
        // );
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      console.error('Failed to fetch vendors:', error);
      dispatch(updateLoader(false));
      dispatch(
        updateSnackbar({
          type: 'error',
          message: error.message || 'Something went wrong',
        })
      );
    }
  };

  const fetchPortalsList = async (id) => {
    try {
      const res = await getApi(
        `${Portals}/${id}?atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const data = res.data;
      const ListofPortals = data.data;
      let obj = JSON.parse(ListofPortals[0].selectedPortals);
      obj.forEach((x) => {
        x['name'] = x.portalName;
        x['id'] = x.portalId.toString();
      });
      setPortals(obj);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  // for dynamic component received props
  const onReceiveActionHandler = async (type, object) => {
    if (type === 'confirmDel') {
      deleteRecords(object);
    } else if (type === 'download') {
      alert('download option is not implemented!');
    } else if (type === 'pagination') {
      if (filterValue !== '') {
        getSearchResult(object, true);
      } else {
        fetchData(object);
      }
    } else if (type === 'searchResult') {
      getSearchResult(object);
    } else if (type === 'cancelSearchResult') {
      setFilterValue('');
      let obj1 = {
        current: 1,
        offset: 1,
      };
      fetchData(obj1);
    } else if (type === 'detailspage') {
      setIsRightSidePannel(true);
      setIsEditVendor(true);
      let vendorObj = {
        id: object.id,
        firstName: object.firstName,
        lastName: object.lastName,
        emailId: object.emailId,
      };
      setSelectedVendor(vendorObj);
    } else if (type === 'detailspage') {
      fetchVendorUserById(object.id);
    } else if (type === 'newApplicants') {
      vendorHandler('Create', ' ');
    } else if (type === 'pageRange') {
      setConfig({
        ...config,
        limitData: (config.limitData = object),
        recordperPage: (config.limitData = object),
      });
    }
  };

  const fetchVendorUserById = async (id) => {
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));
    try {
      const res = await fetch(
        `${process.env.REACT_APP_USE_MANAGEMENT}/mgmt/customer/vendor/${vendorId}/user/${id}?atsAdmin=true`,
        {
          method: 'GET',
          headers: {
            customerid: `${getJobCode}`,
            'Content-Type': 'Application/json',
          },
        }
      );
      const jsonData = await res.json();
      if (jsonData.code === 200) {
        const userArr = jsonData.vendorUser || jsonData['vendorUser '];
        if (userArr && userArr.length > 0) {
          const user = userArr[0];
          setSelectedVendor(user);
          setIsRightSidePannel(true);
          setIsEditVendor(true);
          dispatch(updateLoader(false));
        } else {
          dispatch(updateLoader(false));
          dispatch(
            updateSnackbar({
              type: 'error',
              message: 'User details not found',
            })
          );
        }
      } else {
        dispatch(updateLoader(false));
        dispatch(
          updateSnackbar({
            type: 'error',
            message: jsonData.message || 'Failed to fetch user details',
          })
        );
      }
    } catch (error) {
      dispatch(updateLoader(false));
      dispatch(
        updateSnackbar({ type: 'error', message: 'Network error occurred' })
      );
    }
  };
  const deleteRecords = async (object) => {
    let ids;
    if (typeof object === 'object' && object.length > 0) {
      ids = object.map((x) => x.id.toString());
    } else {
      ids = [object.toString()];
    }
    let obj = { id: ids };
    dispatch(updateSnackbar(initialSnackbar));
    try {
      const deleteJobPost = await patchApi(
        `/mgmt/customer/vendor/${vendorId}/user?atsAdmin=true`,
        obj,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = deleteJobPost.data;
      dispatch(
        updateSnackbar({
          type: jsonData.code === 200 ? 'success' : 'error',
          message: jsonData.message,
        })
      );
      let obj1 = {
        current: config.currentPage,
        offset:
          config.currentPage !== 1
            ? (config.currentPage - 1) * 20 + 1
            : config.currentPage,
      };
      setTimeout(() => {
        fetchData(obj1);
      }, 2000);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  const getSearchResult = async (object, paging) => {
    setVendors([]);
    dispatch(updateLoader(true));
    dispatch(updateSnackbar(initialSnackbar));

    if (paging === true) {
      searchResultWithPaging(object);
    } else {
      setFilterValue(object.keyword);
      searchResultWithoutPaging(object);
    }
  };

  const searchResultWithoutPaging = async (object) => {
    try {
      const res = await getApi(
        `/mgmt/customer/vendor/${vendorId}/users?keyword=${object.keyword}&atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = res.data;
      const myData = jsonData.vendorUsers;
      if (jsonData.code === 200) {
        if (myData !== undefined && myData.length > 0) {
          myData.forEach((e) => {
            e['isChecked'] = false;
          });
          dispatch(updateLoader(false));
          let configure = JSON.parse(JSON.stringify(config));
          configure.totalRecords = jsonData.totalCount;
          configure.currentPage = object.current;
          setConfig(configure);
          setVendors(myData.slice(0, config.limitData));
        } else if (myData.length === 0) {
          dispatch(updateLoader(false));
          let configure = JSON.parse(JSON.stringify(config));
          configure.totalRecords = 0;
          configure.currentPage = 1;
          setConfig(configure);
          setVendors('null');
        }
      } else {
        dispatch(updateLoader(false));
        dispatch(updateSnackbar({ type: 'error', message: '' }));
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  const searchResultWithPaging = async (object) => {
    try {
      const res = await getApi(
        `/mgmt/customer/vendor/${vendorId}/user?limit=${object.offset}&offset=${object.current}&keyword=${filterValue}&atsAdmin=true`,
        process.env.REACT_APP_USE_MANAGEMENT
      );
      const jsonData = res.data;
      const myData = jsonData.user;
      if (jsonData.code === 200) {
        if (myData !== undefined && myData.length > 0) {
          myData.forEach((e) => {
            e['isChecked'] = false;
          });
          dispatch(updateLoader(false));
          let configure = JSON.parse(JSON.stringify(config));
          configure.totalRecords = myData[0].total_count / config.limitData;
          configure.currentPage = object.current;
          setConfig(configure);
          setVendors(myData.slice(0, config.limitData));
        } else if (myData.length === 0) {
          dispatch(updateLoader(false));
          let configure = JSON.parse(JSON.stringify(config));
          configure.totalRecords = 0;
          configure.currentPage = 1;
          setConfig(configure);
          setVendors('null');
        }
      } else {
        dispatch(updateLoader(false));
        dispatch(updateSnackbar({ type: 'error', message: '' }));
      }
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
    }
  };

  const onReceivePropsHandler = (pannel, load) => {
    setIsRightSidePannel(pannel);
    setIsLoadDoc(load);
  };

  const vendorHandler = (type, data) => {
    setIsRightSidePannel(true);
    setSelectedVendor('');
    setIsEditVendor(false);
  };

  return (
    <>
      <div
        className="addNewVendorSection"
        style={{ display: 'flex', height: '34px', gap: '10px' }}
        onClick={() => vendorHandler('Create', ' ')}
      >
        <DashboardPlusicon width={35} height={36} />
        <h4 className="addnewvendorusertext">New Vendor</h4>
      </div>

      <div
        id="customerVendor"
        style={{ background: '#fff', padding: '0px 30px 47px' }}
      >
        {/* for dynamic Table */}
        {vendors.length > 0 && (
          <DynamicTable
            config={config}
            data={vendors}
            colmns={columnsData}
            actionDropdown={actionsDropdownData}
            actions={actionsList}
            filterValue={filterValue}
            noDataText={'No Vendor User Found'}
            addModel={addNewModel}
            searchKeyWord="Search by Name, E-mail ID"
            onReceiveActionProps={(type, obj) =>
              onReceiveActionHandler(type, obj)
            }
          />
        )}
        {vendors.length === 0 && (
          <DynamicTable
            config={config}
            data={vendors}
            colmns={columnsData}
            actionDropdown={actionsDropdownData}
            actions={actionsList}
            filterValue={filterValue}
            addModel={addNewModel}
            noDataText={'No Vendor User Found'}
            searchKeyWord="Search by Name, E-mail ID"
            onReceiveActionProps={(type, obj) =>
              onReceiveActionHandler(type, obj)
            }
          />
        )}
      </div>

      <div className="rightsidebarbtn">
        {isRightSidePannel ? (
          <RightSideBar
            id="CustomerVendor"
            componentData={
              <ComponentRenderData
                componentType={isEditVendor ? 'EditVendor' : 'AddVendor'}
                onReceivechildProps={onReceivePropsHandler}
                portalData={portals}
                getJobCode={getUserId}
                input={isEditVendor ? selectedVendor : vendorsForm}
                vendorId={vendorId}
              />
            }
            componentLayout={isEditVendor ? editPannelobj : pannelobj}
            onReceiveProps={onReceivePropsHandler}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

const ComponentRenderData = ({
  onReceivechildProps,
  componentType,
  portalData,
  getJobCode,
  input,
  vendorId,
}) => {
  const [radioValue, setRadioValue] = useState('Vendor');
  const [vendorDetails, setvendorDetails] = useState(input);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [imgList, setImgList] = useState([]);
  const [imgData, setImgData] = useState([]);
  const [fileType, setFileType] = useState('jpg not supported');
  const [showUploadImg, setShowUploadImg] = useState('');
  const [previewData, setPreviewData] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialSnackbar = { type: '', message: '' };
  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  const RadiohandleChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleChange = (event) => {
    let { name, value } = event.target;
    if (name === 'emailId') {
      value = value.toLowerCase();
      value = value.trim();
    }
    formik.values[name] = value;
    setvendorDetails((prevValues) => ({ ...prevValues, [name]: value }));
  };

  useEffect(() => {}, [vendorDetails]);

  const validRegex = /^[a-zA-Z0-9_!#$%&*+/=?`{}~^.-]+@[a-zA-Z0-9.-]+$/;

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .min(2, 'Must be min 2 characters')
      .max(20, 'Must be less than 20 ')
      .required('Please enter first name'),
    lastName: Yup.string().required('Please enter last name'),
    emailId: Yup.string()
      .email('Please enter E-mail address')
      .matches(validRegex, 'Invalid E-mail address')
      .required('Please enter E-mail address'),
  });

  const formik = useFormik({
    initialValues: input,
    validationSchema,
    onSubmit: async (value) => {
      const isEdit = componentType === 'EditVendor';
      if (!isEdit) {
        value.customerId = getJobCode;
      }
      setDisableSubmitBtn(true);
      dispatch(updateLoader(true));
      dispatch(updateSnackbar(initialSnackbar));
      try {
        const res = isEdit
          ? await putApi(
              `/mgmt/customer/vendor/${vendorId}/user/${vendorDetails.id}?atsAdmin=true`,
              value,
              process.env.REACT_APP_USE_MANAGEMENT
            )
          : await postApi(
              `/mgmt/customer/vendor/${vendorId}/user?atsAdmin=true`,
              value,
              process.env.REACT_APP_USE_MANAGEMENT
            );

        const json = res.data;
        setDisableSubmitBtn(false);

        if (json.code === 200) {
          setvendorDetails([]);
          setTimeout(() => {
            dispatch(updateLoader(false));
            dispatch(
              updateSnackbar({ type: 'success', message: json.message })
            );
          }, 1200);

          onReceivechildProps(false, true);
        } else {
          throw new Error(json.message || 'Something went wrong');
        }
      } catch (error) {
        if (
          error?.response?.status === 405 ||
          error?.response?.status === 406
        ) {
          return sessionExpired(error?.response?.data?.message);
        }
        setDisableSubmitBtn(false);
        dispatch(updateLoader(false));
        dispatch(
          updateSnackbar({
            type: 'error',
            message: error?.response?.data?.message || 'Something went wrong',
          })
        );
      }
    },
  });

  const uploadImgHandler = (files) => {
    setShowUploadImg(URL.createObjectURL(files[0]));
    // let imgNames = JSON.parse(JSON.stringify(imgList));
    // let imgObj = JSON.parse(JSON.stringify(imgData));
    // let tempImgNames = [],
    //   tempImgObj = [];
    // for (var i = 0; i < files.length; i++) {
    //   let obj = { id: i, name: files[i].name };
    //   tempImgNames.push(obj);
    //   tempImgObj.push(files[i]);
    // }
    // imgNames.push(...tempImgNames);
    // imgObj.push(...tempImgObj);
    // setImgList(imgNames);
    // setImgData(imgObj);
    // setIsUploaded(false);
  };

  const onRemoveItem = (item) => {
    let imgNames = JSON.parse(JSON.stringify(imgList));
    let findIndex = imgNames.findIndex((x) => x.id === item.id);
    if (findIndex !== -1) {
      imgNames.splice(findIndex, 1);
      setImgList(imgNames);
    }
    imgData.splice(parseInt(item.id), 1);
    setImgData(imgData);
  };

  // useEffect(() => {}, [imgList]);

  // useEffect(() => {}, [imgData]);

  const uploadDocuments = async () => {
    try {
      if (!imgData || imgData.length === 0) {
        alert('No files selected');
        return;
      }

      const allowedTypes = /\.(jpg|jpeg|png|svg)$/i;
      const invalidFiles = imgData.filter(
        (file) => !allowedTypes.test(file.name)
      );

      if (invalidFiles.length > 0) {
        alert(
          'Some selected files are not supported. Allowed: JPG, JPEG, PNG, SVG'
        );
        return;
      }

      const formData = new FormData();
      imgData.forEach((file) => formData.append('vendorFiles', file));

      const res = await postApi(
        `/mgmt/customer/mulitplevendor?atsAdmin=true`,
        formData,
        'http://3.97.4.103:2005',
        true
      );
      const data = res.data;
      onReceivechildProps(false, true);
    } catch (error) {
      if (error?.response?.status === 405 || error?.response?.status === 406) {
        return sessionExpired(error?.response?.data?.message);
      }
      console.error('Document upload error:', error);
    }
  };

  const uploadExcel = (xlfiles) => {
    let getColums = [],
      getExcelData = [];
    readXlsxFile(xlfiles[0]).then((rows) => {
      getColums = rows[0];
      for (var i = 1; i < rows.length; i++) {
        let getEachObj = {};
        rows[i].forEach((each, j) => {
          let column = JSON.parse(JSON.stringify(getColums));
          let obj = { [column[j]]: each };
          getEachObj = { ...getEachObj, ...obj };
        });
        getEachObj['customerId'] = 2; //need to be update;
        getExcelData.push(getEachObj);
      }
      // setIsUploaded(false);
      setPreviewData(getExcelData);
    });
  };

  return (
    <>
      <div id="radiobtn" style={{ marginBottom: '40px' }}>
        {componentType !== 'EditVendor' ? (
          <FormControl>
            <RadioGroup
              style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={radioValue}
              onChange={RadiohandleChange}
            >
              <FormControlLabel
                value="Vendor"
                control={<Radio />}
                label="Vendor"
              />
              <FormControlLabel
                value="bulkupload"
                control={<Radio />}
                label="Bulk Upload"
                disabled
              />
            </RadioGroup>
          </FormControl>
        ) : (
          ''
        )}
      </div>
      {radioValue === 'Vendor' && vendorDetails.firstName !== undefined ? (
        <div className="groupfields">
          <ProfileIcon
            primaryColor={storedTheme?.primaryColor}
            primaryFontColor={storedTheme?.primaryFontColor}
          />
          <FocusError formik={formik} />
          <div
            style={{
              display: 'flex',
              flexFlow: 'wrap',
              marginTop: '40px',
              gap: '25px',
            }}
          >
            <div style={{ width: '48%' }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="First Name* &nbsp;"
                variant="outlined"
                style={{ width: '100%' }}
                name="firstName"
                value={vendorDetails.firstName}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.firstName && formik.touched.firstName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.firstName && formik.touched.firstName
                    ? formik.errors.firstName
                    : ''
                }
              />
            </div>

            <div style={{ width: '48%' }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="Last Name* &nbsp;"
                variant="outlined"
                style={{ width: '100%' }}
                name="lastName"
                value={vendorDetails.lastName}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.lastName && formik.touched.lastName
                    ? true
                    : false
                }
                helperText={
                  formik.errors.lastName && formik.touched.lastName
                    ? formik.errors.lastName
                    : ''
                }
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexFlow: 'wrap',
              marginTop: '30px',
              gap: '25px',
            }}
          >
            <div style={{ width: '48%' }}>
              <TextField
                className="boldlabelvendor"
                id=""
                label="E-mail Address* &nbsp;"
                variant="outlined"
                style={{ width: '100%' }}
                name="emailId"
                value={vendorDetails.emailId}
                onChange={handleChange}
                onBlur={formik.handleBlur}
                InputLabelProps={{ shrink: true }}
                error={
                  formik.errors.emailId && formik.touched.emailId ? true : false
                }
                helperText={
                  formik.errors.emailId && formik.touched.emailId
                    ? formik.errors.emailId
                    : ''
                }
              />
            </div>
          </div>
          <div className="vendor-user-footer">
            <Button
              className="vendorsavebtn"
              variant="contained"
              type="submit"
              disableSubmitBtn={disableSubmitBtn}
              onClick={formik.handleSubmit}
            >
              {componentType === 'EditVendor' ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      ) : radioValue === 'bulkupload' ? (
        <>
          <a
            href={
              process.env.PUBLIC_URL + '/assests/OnboardingTemplateFormat.xlsx'
            }
            download
            style={{ float: 'right' }}
          >
            Onboarding Template Format
          </a>
          <div
            style={{ marginTop: '80px' }}
            className={previewData.length > 0 ? 'd-none' : ''}
          >
            {/* reduceuploadSize */}
            <img
              src={process.env.PUBLIC_URL + '/assests/img/uploadBgIcon.svg'}
              alt="upload image"
            />
            <Button
              variant="contained"
              component="label"
              className="uploadSection"
            >
              <span>Upload</span> <span>Browse file to upload</span>
              <input
                hidden
                accept=".xls,.xlsx"
                type="file"
                onChange={(e) => uploadExcel(e.target.files)}
              />
            </Button>
            <p className="docsupporttext">
              Supported file formats: .xls, .xlsx
            </p>
            <div className="imgBox">
              <img
                src={process.env.PUBLIC_URL + '/assests/img/Bulkuploadbg.svg'}
                alt=""
              />
            </div>
          </div>
          {previewData.length > 0 ? (
            <div>
              <div
                style={{
                  maxHeight: 'calc(100vh - 500px)',
                  overflow: 'hidden auto',
                  display: 'block',
                  background: '#fff',
                  boxShadow: '0px 0px 5px #d4d4d4',
                  padding: '10px',
                  width: '100%',
                  marginTop: '49px',
                }}
              >
                <table
                  border="1"
                  cellPadding={5}
                  cellSpacing={0}
                  style={{ width: '100%', border: 'none' }}
                >
                  <thead>
                    <tr align="center">
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>E-mail Id</th>
                    </tr>
                  </thead>
                  <tbody>
                    {previewData.length > 0 &&
                      previewData.map((item, i) => {
                        return (
                          <tr key={i} align="left">
                            <td>{item.firstName}</td>
                            <td>{item.lastName}</td>
                            <td>{item.emailId}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              <div className="actionBtns">
                <Button
                  type="button"
                  className="cancelBtn"
                  onClick={() => {
                    onReceivechildProps(false, false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  variant="contained"
                  className="saveBtn"
                  onClick={uploadDocuments}
                  disabled={previewData.length > 0 ? false : true}
                >
                  Save
                </Button>
              </div>
              <div className="imgBox">
                <img
                  src={process.env.PUBLIC_URL + '/assests/img/Bulkuploadbg.svg'}
                  alt=""
                />
              </div>
            </div>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
};
export default Vendors;

const pannelobj = {
  title: 'Vendor User',
  description: '',
  bgImage: '',
};

const editPannelobj = {
  title: 'Edit Vendor User',
  description: '',
  bgImage: '',
};

// for dynamic Table config Object
const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 10,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: true,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const actionsDropdownData = ['Delete'];

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isDelete: false,
};

const iniValues = {
  firstName: '',
  lastName: '',
  emailId: '',
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: 'First Name',
    mappingName: 'firstName',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' dynatablebodytext text-center ',
    type: 'vendors',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 2,
    displayName: 'Last Name',
    mappingName: 'lastName',
    theadClass: 'dynatableheadtext text-center ',
    tbodyClass: ' dynatablebodytext text-center',
    type: 'vendors',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
  {
    id: 3,
    displayName: 'E-mail ID',
    mappingName: 'emailId',
    theadClass: 'dynatableheadtext text-center',
    tbodyClass: ' text-center',
    type: 'vendors',
    width: '',
    isEdit: true,
    nagigate: 'detailspage',
  },
];

const addNewModel = {
  url: '',
  displayName: '',
};
